import { DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import PdfViewer from "../PdfViewer";
import { Dialog, DialogContent } from "../ui/dialog";

export default function PdfViewerModal({
  url,
  width = 635,
  height = 750,
  onClose,
}: {
  url: string;
  width?: number;
  height?: number;
  onClose: () => void;
}) {
  return (
    <Dialog open={!!url} onOpenChange={onClose}>
      <DialogContent>
        <DialogTitle style={{ display: "none" }}>PDF Viewer</DialogTitle>
        {/* throws a console error if this is not here */}
        <DialogDescription style={{ display: "none" }}>
          {/* throws a console error if this is not here */}
          PDF Viewer
        </DialogDescription>
        <div style={{ width: `${width}px` }}>
          <PdfViewer url={url} width={width} height={height} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
